import './paginate.css';
import ReactPaginate from 'react-paginate';

export default function Paginate ({qtdPaginas, handlePageClick, currentPage}) {
  return (
    <ReactPaginate 
      previousLabel="< Anterior"
      nextLabel="Próximo >"
      breakLabel="..."
      pageCount={qtdPaginas}
      onPageChange={handlePageClick}
      forcePage={currentPage}
      containerClassName="pagination"
      pageLinkClassName='page-num'
      nextLinkClassName='page-num'
      previousLinkClassName='page-num'
      activeClassName="active"
    />            
  )
}
